import type { ReactNode } from "react";

// Uniform card chrome for every content section on the node-detail page
// (§3 of the 2026-09-23 rework: "a header strip with the title and, where
// it helps, a one-line description ... consistent chrome across all of
// them so the page scans"). Originally a local function inside
// NodeDetailPage.tsx; pulled out here (2026-09-23, Commands/reorder pass)
// so components that decide FOR THEMSELVES whether they have anything
// worth a full card — ReconciliationSection, NodeCommandsSection — can
// render the same chrome, or skip it and render a minimal note/nothing
// instead, without NodeDetailPage having to know their internal fetch
// state up front. Purely presentational — no content/data logic here.
export function SectionCard({ title, description, children }: { title: string; description?: string; children: ReactNode }) {
  return (
    <section className="node-detail-card">
      <div className="node-detail-card-header">
        <h3>{title}</h3>
        {description && <p className="node-detail-card-desc">{description}</p>}
      </div>
      <div className="node-detail-card-body">{children}</div>
    </section>
  );
}
